import React from 'react'
import QuoteEditor from "./QuoteEditor"
import { INVENTORY_TYPE } from '../../helpers/constants'

const UnitQuotationView = () => (
  <QuoteEditor inventoryType={INVENTORY_TYPE.unit} />
)

export default  UnitQuotationView
